import { motion } from "framer-motion";

const PATHS = [
  "M4 4H96V96H4Z",
  "M11 13H41", "M11 22H41", "M11 31H41", "M11 40H41",
  "M50 12V89", "M50 52H88",
  "M61 74a14 14 0 1 0 28 0a14 14 0 1 0 -28 0",
  "M11 89V67a15 15 0 0 1 30 0V89Z",
  "M18.5 89V67a7.5 7.5 0 0 1 15 0V89",
  "M73 44V22",
  "M73 23Q74 12 88 11Q87 22 73 23Z",
  "M73 37Q74 27 88 26Q87 36 73 37Z",
  "M71 31Q70 21 58 21Q59 30 71 31Z",
];

export const LogoMark = ({ className = "", draw = false, strokeWidth = 4.5, framed = true }) => (
  <svg viewBox={framed ? "-3 -3 106 106" : "6 6 88 88"} className={className} fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {(framed ? PATHS : PATHS.slice(1)).map((d, i) => (
      <motion.path
        key={d}
        d={d}
        initial={draw ? { pathLength: 0, opacity: 0 } : false}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{ duration: 0.9, delay: draw ? i * 0.045 : 0, ease: [0.65, 0, 0.35, 1] }}
      />
    ))}
  </svg>
);

export const Logo = ({ className = "", compact = false }) => (
  <span className={`inline-flex items-center gap-3 ${className}`}>
    <LogoMark className="h-9 w-9 shrink-0" strokeWidth={5} />
    {!compact && (
      <span className="flex flex-col leading-none">
        <span className="font-display text-[17px] font-normal tracking-[0.32em]">BIO SMART</span>
        <span className="mt-1 font-display text-[10px] font-normal tracking-[0.42em]">SOLUTIONS</span>
      </span>
    )}
  </span>
);
